import {combineEpics} from 'redux-observable';
import {authEpic, fetchProfileEpic, fetchProfileSuccessEpic, logoutEpic, resetPasswordEpic} from './auth';

const rootEpic = combineEpics(
  authEpic,
  fetchProfileEpic,
  fetchProfileSuccessEpic,
  logoutEpic,
  resetPasswordEpic,
);

export default rootEpic;


// WEBPACK FOOTER //
// ./src/epics/index.js